import { useIsProductionSelector } from "hooks/selectors/useAppEnvironmentSelector";

export function useEnvironmentName() {
  const isProductionEnvironment = useIsProductionSelector();

  return isProductionEnvironment ? "production" : "sandbox";
}
